import React from 'react'
import dayjs from 'dayjs'
import './index.scss'

const CardMetricVariation = ({ metricVariation }) => {
  if (!metricVariation || metricVariation === 0) {
    return null
  }

  const currentMonth = dayjs().subtract('1', 'month').format('MMM')
  const lastMonth = dayjs().subtract('2', 'month').format('MMM')

  return (
    <div className="CardMetricVariation">
      <div className="variation-centered">
        <span
          className={`metric-variation ${
            metricVariation > 0 ? 'metric-variation-positive' : 'metric-variation-negative'
          }`}
        >
          {metricVariation > 0 && <>+</>}

          {`${metricVariation.toFixed(1)}%`}
        </span>
      </div>

      <div className="CardMetricVariation-metrics">
        {lastMonth}-{currentMonth}
      </div>
    </div>
  )
}

export default CardMetricVariation
